import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "sm:w-full flex flex-col p-5 bg-white shadow hover:shadow-lg rounded-2xl cursor-pointer" }
const _hoisted_2 = { class: "sm:flex items-center justify-center w-full" }
const _hoisted_3 = { class: "sm:flex sm:w-full items-center" }
const _hoisted_4 = { class: "flex justify-center items-center rounded-full bg-primary text-white w-10 h-10 p-2" }
const _hoisted_5 = { class: "sm:flex flex-col px-2 w-full" }
const _hoisted_6 = { class: "leading-none text-md pt-1 font-bold" }
const _hoisted_7 = { class: "flex flex-row justify-between w-full items-center" }
const _hoisted_8 = { class: "text-gray-400 leading-none mt-1 text-sm pt-1 flex" }
const _hoisted_9 = { class: "text-gray-400 leading-none mt-1 text-sm pt-1 flex hover:text-primary" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "py-2 px-2",
      key: `card-candidate-${item.first_name}-${item.last_name}-${index}`
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.getInitials(`${item.first_name} ${item.last_name}`)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(`${item.first_name} ${item.last_name}`), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.position), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.addToJob(item.id))
                  }, _hoisted_12, 8, _hoisted_10)
                ])
              ])
            ])
          ])
        ])
      ])
    ]))
  }), 128))
}